import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { AddOnsAccessLayout } from 'pages/settings/pages/addOns/layout/AddOnsAccessLayout'
import { AddOnsPageLayout } from 'pages/settings/pages/addOns/layout/AddOnsPageLayout'
import { AddOnsView } from 'pages/settings/pages/addOns/AddOnsView'

export const AddOnsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<AddOnsAccessLayout />}>
        <Route element={<AddOnsPageLayout />}>
          <Route index element={<AddOnsView />} />
        </Route>
      </Route>
    </Routes>
  )
})
